if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.addEventListener('change', this.onVariantChange);

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';

      // Ensure the CSS class we use for variant image filtering is defined.
      if (this.hideVariants && !document.getElementById('hv-variant-hide-styles')) {
        const style = document.createElement('style');
        style.id = 'hv-variant-hide-styles';
        style.textContent = `
          .product-images__slide.is-hidden,
          .product-thumbnail.is-hidden { display: none !important; }
        `;
        document.head.appendChild(style);
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.__vaConnectedCallbackExtra();
    }

    onVariantChange(event) {
      // VA FIX: se este 'change' foi disparado sinteticamente pelo overlay do
      // tema (para recalcular o estado das swatches depois de um refresh de
      // secção), não voltar a correr todo o onVariantChange — isso despachava
      // um segundo "product:variant-change" e atualizava media/ATC outra vez,
      // causando um refresh duplicado visível nas reviews e no Shop Pay.
      if (window.__vaSkipNextSyntheticChange) return;

      this.updateOptions();
      this.updateMasterId();

      // VA FIX: se a combinação atual (ex: tamanho recém-escolhido + cor que já
      // estava selecionada) não existir ou não tiver stock, procurar a primeira
      // variante disponível que ainda respeite o valor que o utilizador acabou
      // de escolher, e atualizar as restantes opções para essa combinação —
      // em vez de ficar "preso" numa combinação esgotada/inexistente.
      if ((!this.currentVariant || !this.currentVariant.available) && event && event.target) {
        const changedFieldset = event.target.closest('fieldset');
        const changedIndex = changedFieldset ? this.fieldsets.indexOf(changedFieldset) : -1;

        if (changedIndex !== -1) {
          // VA FIX: só fazemos o "salto" automático para uma variante disponível
          // quando a opção alterada NÃO é a cor — ou seja, quando mudas de
          // tamanho e a cor selecionada fica sem stock/inexistente nesse tamanho.
          // Se o utilizador clicar diretamente numa cor sem stock, essa escolha
          // mantém-se (não salta para outra cor sozinho).
          const changedOptionName = String(changedFieldset.dataset.handle || changedFieldset.querySelector('.form__label')?.textContent || '');
          const changedIsColor = /colou?r/i.test(changedOptionName);

          if (!changedIsColor) {
          const changedValue = this.options[changedIndex];
          const variant_data = this.getVariantData();
          let candidates = variant_data.filter((v) => v.available && v.options[changedIndex] === changedValue);

          // VA FIX: se não houver nenhuma variante DISPONÍVEL a combinar com o
          // valor recém-escolhido (ex: os dois tamanhos estão totalmente
          // esgotados e não partilham a mesma cor), isso deixava candidates
          // vazio e o código não saltava para lado nenhum — ficando numa
          // combinação que nem sequer existe no backend (currentVariant
          // undefined), o que mostrava um preço de recurso quebrado
          // (ex: "19.99") em vez do preço real da variante esgotada. Cair
          // para qualquer variante que EXISTA (mesmo sem stock) é sempre
          // melhor do que ficar numa combinação inexistente.
          if (!candidates.length) {
            candidates = variant_data.filter((v) => v.options[changedIndex] === changedValue);
          }

          if (candidates.length) {
            // Preferir a variante disponível que mais se aproxima da seleção
            // atual nas restantes opções (ex: manter o mesmo material se possível).
            let fallback = candidates[0];
            let bestScore = -1;
            candidates.forEach((v) => {
              let score = 0;
              v.options.forEach((val, idx) => {
                if (idx !== changedIndex && val === this.options[idx]) score++;
              });
              if (score > bestScore) {
                bestScore = score;
                fallback = v;
              }
            });

            this.fieldsets.forEach((fieldset, i) => {
              if (i === changedIndex) return;
              const value = fallback.options[i];
              const select = fieldset.querySelector('select');
              if (select) {
                select.value = value;
              } else {
                const input = Array.from(fieldset.querySelectorAll('input')).find((inp) => inp.value === value);
                if (input) input.checked = true;
              }
            });

            this.updateOptions();
            this.updateMasterId();
          }
          }
        }
      }

      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      if (!this.currentVariant) {
        // VA: In high-variant mode (>250), the variant may be resolved outside of product.js.
        // If we already have a variant id in the ATC form, do NOT force the button into "UNAVAILABLE" state here.
        // The main-product script will sync real availability via /variants/<id>.js.
        const __vaIdEl = this.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
        const __vaResolvedId = __vaIdEl && __vaIdEl.value ? String(__vaIdEl.value) : '';
        if (__vaResolvedId) {
          // Keep disabled, but do not overwrite the label with "UNAVAILABLE"
          this.toggleAddButton(true, false, true);
        } else {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        }
      } else {
        this.updateMedia();
    // VA: store featured media to re-apply after section HTML refresh (prevents slider resetting to first image)
    this._vaPendingFeaturedMediaId = this.currentVariant?.featured_media?.id || null;

        // VA FIX: em vez de forçar reload total da página quando se aterra numa
        // variante esgotada (o que era necessário porque o "Notify me" da
        // Klaviyo só verificava a disponibilidade uma vez, no carregamento),
        // pedimos diretamente à Klaviyo para reabrir o formulário de Back in
        // Stock (via _klOnsite.push(['openForm', ...])), que reavalia a
        // variante selecionada no momento em que é chamado — sem reload.
        // O resto do fluxo AJAX (preço, imagem, URL) continua normalmente,
        // tal como para qualquer outra variante.
        if (!this.currentVariant.available && window._klOnsite && typeof window._klOnsite.push === 'function') {
          try {
            window._klOnsite.push(['openForm', '27662532']);
          } catch (e) {}
        }

        if (this.updateUrl) {
          this.updateURL();
        }
          // VA: avoid section refresh when price is unchanged (prevents Payment Terms flicker/layout shift on color-only changes)
        const __vaPriceKey = `${this.currentVariant?.price ?? ''}|${this.currentVariant?.compare_at_price ?? ''}`;
        if (this.__vaLastPriceKey === __vaPriceKey) {
          // VA FIX: mesmo saltando o fetch pesado do renderProductInfo(), o
          // texto do botão Add to Cart tem de ser sempre sincronizado com o
          // currentVariant atual. Sem isto, se duas variantes seguidas
          // tivessem o mesmo preço (ex: Twin e King), o botão nunca era
          // corrigido — e se por algum motivo tivesse ficado preso em
          // "Unavailable" nalgum momento transitório, ficava assim até um
          // preço diferente aparecer (ou um reload manual).
          this.toggleAddButton(
            !this.currentVariant.available,
            this.currentVariant.available ? window.theme.variantStrings.addToCart : window.theme.variantStrings.soldOut
          );
          // keep payment terms updated without re-rendering price HTML
          try {
            const terms = document.querySelector('shopify-payment-terms');
            if (terms) terms.setAttribute('variant-id', String(this.currentVariant.id));
          } catch (e) {}
        } else {
          this.__vaLastPriceKey = __vaPriceKey;
          this.renderProductInfo();
        }
        //this.updateShareUrl();
      }
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      // remember last desired media id so we can restore after section refresh re-renders the gallery
      try {
        const vMediaId = this.currentVariant?.featured_media?.id;
        if (vMediaId) window.__vaLastMediaId = String(vMediaId);
      } catch (e) {}

      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      // Defer media switching until after any section refresh has completed to avoid the


      // 'correct image -> refresh -> first image -> correct image' flicker.


      this.__vaSetPendingMedia(String(this.currentVariant.featured_media.id));
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      const activeMedia = productSlider ? productSlider.querySelector(mediaId) : null;
      const activeThumb = thumbnails ? thumbnails.querySelector(thumbId) : null;

      // Theme may not expose Flickity instance via window.Flickity.data() reliably —
      // especially when the slider was initialized while hidden (e.g. inside a closed drawer),
      // in which case Flickity computed zero-width cell positions and needs a resize() first.
      // Prefer the <product-slider> custom element's own .flkty property (same pattern used
      // for the mobile detection elsewhere in this file), which stays valid regardless.
      let flkty = null;
      try {
        flkty = productSlider?.flkty || ((window.Flickity && productSlider) ? window.Flickity.data(productSlider) : null);
        if (flkty && typeof flkty.resize === 'function') {
          flkty.resize();
        }
      } catch (e) {}

      // Clean existing active states (safe-guarded)
      if (productSlider) {
        const initial = productSlider.querySelector('.product-images__slide.is-initial-selected');
        if (initial) initial.classList.remove('is-initial-selected');

        productSlider.querySelectorAll('.product-images__slide-item--variant').forEach((el) => el.classList.remove('is-active'));
      }
      if (activeMedia) {
        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');
      }

      this.setImageSetMedia?.();

      if (thumbnails) {
        const tInitial = thumbnails.querySelector('.product-thumbnail.is-initial-selected');
        if (tInitial) tInitial.classList.remove('is-initial-selected');

        thumbnails.querySelectorAll('.product-images__slide-item--variant').forEach((el) => el.classList.remove('is-active'));

        if (activeThumb) {
          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }
      }

      // VA: Flickity focuses its gallery container (tabindex="0", set by Flickity itself) whenever
      // selectCell()/select() runs, for keyboard-nav accessibility. Because nothing passes
      // { preventScroll: true } to that internal focus() call, the browser's native
      // "scroll focused element into view" fires — this is the real, long-standing source of the
      // mobile jump-to-top (see metafizzy/flickity#194, #325). It affects EVERY caller of
      // setActiveMedia() (immediate rAF path, MutationObserver path, and the 900ms fallback timer
      // in __vaSetPendingMedia, which previously had no scroll protection at all). Locking here,
      // in the one place all of them funnel through, covers all of them at once.
      // VA: mobile only — this lock exists purely to stop the mobile page-jump caused by
      // Flickity's focus-on-select. On desktop there's no scroll-jump problem, and locking here
      // unconditionally was interfering with the carousel's own image-focus switching. Restricting
      // to mobile removes that interference while keeping the mobile fix intact.
      const __vaIsMobileSAM = !window.matchMedia('(min-width: 768px)').matches;
      const __vaSavedY = __vaIsMobileSAM ? __vaLockPageScroll() : null;
      const __vaReleaseLock = () => {
        if (!__vaIsMobileSAM) return;
        requestAnimationFrame(() => requestAnimationFrame(() => __vaUnlockPageScroll(__vaSavedY)));
      };

      // 1) If Flickity is accessible, select the actual element for smooth animation.
      if (flkty && typeof flkty.selectCell === 'function' && activeMedia) {
        try {
          flkty.selectCell(activeMedia, false, false);
          __vaReleaseLock();
          return;
        } catch (e) {}
      }

      // 2) Otherwise, trigger the theme's existing thumbnail click logic (this is what works manually).
      if (activeThumb && typeof activeThumb.click === 'function') {
        activeThumb.click();
        __vaReleaseLock();
        return;
      }

      // 3) Fallback: try to scroll the active media into view (may not work if slider uses transforms)
      if (activeMedia && typeof activeMedia.scrollIntoView === 'function') {
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
      __vaReleaseLock();
    }


    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput({ dispatchChange = true } = {}) {
      const mainForm = document.querySelector(`#product-form-${this.dataset.section}`);
      if (mainForm) {
        const input = mainForm.querySelector('input[name="id"]');
        if (input) {
          input.value = this.currentVariant.id;
          if (dispatchChange) {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      // Keep installment form's hidden variant id in sync,
      // but NEVER dispatch "change" here to avoid payment terms flicker.
      const instForm = document.querySelector('#product-form-installment');
      if (instForm) {
        const input = instForm.querySelector('input[name="id"]');
        if (input) input.value = this.currentVariant.id;
      }
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`];
    }

    renderProductInfo() {
      // Atualizar o estado do botão Add to Cart de imediato, independentemente
      // do caminho usado para atualizar o resto da informação do produto.
      this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

      // VA FIX: quando o overlay do tema (main-product.liquid) já trata a
      // atualização de preço/inventário/reviews/Shop Pay através do seu próprio
      // refreshSection() / refreshVariantIdOnly(), não duplicar aqui o mesmo
      // fetch + substituição de HTML. Estava a causar um "duplo refresh"
      // (dois pedidos de rede independentes a resolver em momentos diferentes,
      // cada um a substituir o mesmo conteúdo), visível sobretudo nas reviews
      // e no botão Shop Pay, que têm de se reinicializar de cada vez que o
      // HTML à sua volta é substituído.
      if (window.__vaOverlayHandledSections && window.__vaOverlayHandledSections.has(this.dataset.section)) return;

      let sections = this.getSectionsToRender();
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          // VA: lock scroll position during the DOM swap below — prevents the mobile
          // "flash to variants then jump to top" caused by scroll-anchoring on the
          // innerHTML replacement plus the setActiveMedia() gallery scroll that follows.
          const __vaSavedY = __vaLockPageScroll();

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            // VA: after the DOM has been replaced, reselect the correct media (avoids reset to first slide)
            if (this._vaPendingFeaturedMediaId) {
              const mediaId = `#Slide-${this.dataset.section}-${this._vaPendingFeaturedMediaId}`;
              const thumbId = `#Thumb-${this.dataset.section}-${this._vaPendingFeaturedMediaId}`;
              requestAnimationFrame(() => {
                const ps = this.productSlider || this.closest('.thb-product-detail')?.querySelector('.product-images');
                this.setActiveMedia(mediaId, thumbId, ps, this.thumbnails);
              });
              this._vaPendingFeaturedMediaId = null;
            }

            const price = document.getElementById(id);

            if (price) price.classList.remove('visibility-hidden');
          });

          // VA: release the lock only after the setActiveMedia() rAF above has had a chance
          // to run and settle (double rAF), otherwise we'd unlock before the jump happens.
          requestAnimationFrame(() => requestAnimationFrame(() => __vaUnlockPageScroll(__vaSavedY)));
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      // Robust label setter: themes may nest the visible label in different nodes.
      const setLabel = (t) => {
        const target = [...addButton.querySelectorAll('*')].find((x) => {
          const s = (x.textContent || '').trim().toLowerCase();
          return s === 'sold out' || s === 'unavailable' || s === 'add to cart' || s === 'pre-order';
        }) || addButtonText || addButton;
        target.textContent = t;
      };

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) setLabel(text);
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('loading');
        // Ensure we fully clear any sold-out styling left from an unavailable combination.
        addButton.classList.remove('sold-out');
        addButton.classList.remove('button--sold-out');

        const isPreorder = productTemplate?.includes('pre-order');
        setLabel(isPreorder ? window.theme.variantStrings.preOrder : window.theme.variantStrings.addToCart);

      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add('sold-out');
      if (price) price.classList.add('visibility-hidden');
    }

    setDisabled() {
      // If the embedded variant JSON is truncated (common at 250+ variants),
      // client-side availability becomes wrong. In that case, don't disable swatches here.
      if (Array.isArray(this.variantData) && this.variantData.length >= 250) {
        return;
      }

      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          // VA FIX: usar sempre os valores realmente selecionados no DOM (this.options)
          // em vez de "adivinhar" a cor a partir da primeira variante que bata certo com
          // o tamanho (option1). A versão antiga ignorava a cor realmente escolhida e
          // corrompia toda a árvore de disponibilidade quando a combinação tamanho+cor
          // selecionada não tinha variante correspondente (ex: tamanho sem stock nessa cor),
          // causando swatches disponíveis marcados como esgotados e outros bloqueados a clique.
          selected_options = this.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        // VA FIX: "esgotado" (a variante existe, só não tem stock) e "esta
        // combinação nunca foi criada no backend" são coisas diferentes — a
        // árvore acima (createAvailableOptionsTree) trata os dois casos da
        // mesma forma (marca como isUnavailable). Aqui verificamos, para cada
        // valor, se existe MESMO alguma variante com esse valor + todos os
        // outros valores atualmente selecionados (independentemente de ter
        // stock ou não). Se não existir nenhuma, escondemos o swatch por
        // completo em vez de o mostrar riscado — não devia sequer aparecer.
        // VA FIX: a versão anterior verificava se o valor existia combinado
        // com as OUTRAS opções atualmente selecionadas — o que escondia
        // valores válidos (ex: um tamanho que existe, só não combina com a
        // cor que calhava estar selecionada no momento). Um valor só deve
        // ficar escondido se não existir em NENHUMA variante, com nenhuma
        // combinação de outras opções — isso sim é um valor que nunca foi
        // criado no backend. A troca para uma combinação que não existe (mas
        // cujos valores existem individualmente) já é tratada à parte pelo
        // salto automático em onVariantChange().
        // VA FIX: a verificação tem de ser assimétrica, não igual para todas
        // as opções. O Tamanho (option1) deve sempre mostrar todos os valores
        // que existem no produto, seja qual for a cor selecionada — só assim
        // não desaparece um tamanho válido (ex: King) por não combinar com a
        // cor que calhava estar selecionada. Já a Cor (option2+) deve
        // filtrar-se pelo Tamanho atualmente selecionado — para não continuar
        // a mostrar uma cor (ex: White) que não existe nesse tamanho (ex:
        // King), já que essa combinação em concreto não existe no backend.
        const comboExists = (fieldsetIndex, value) => {
          if (fieldsetIndex === 0) {
            return variant_data.some((variant) => String(variant.options[0]) === String(value));
          }
          const primaryValue = this.options[0];
          return variant_data.some((variant) => (
            String(variant.options[fieldsetIndex]) === String(value) &&
            String(variant.options[0]) === String(primaryValue)
          ));
        };

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                const optEl = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                if (optEl) {
                  const doesNotExist = !comboExists(i, option.value);
                  optEl.classList.toggle('is-disabled', !!option.isUnavailable);
                  optEl.disabled = false;
                  optEl.hidden = doesNotExist;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input) => {
                // Match by value; index-based mapping breaks when DOM differs from computed options (common after refresh / 250+ variants)
                const opt = Array.isArray(fieldset_options)
                  ? fieldset_options.find(o => o && String(o.value) === String(input.value))
                  : null;
                const isUnavailable = !!(opt && opt.isUnavailable);
                input.classList.toggle('is-disabled', isUnavailable);
                input.removeAttribute('disabled');

                const doesNotExist = !comboExists(i, input.value);
                const label = input.closest('label') || (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
                input.style.display = doesNotExist ? 'none' : '';
                if (label) label.style.display = doesNotExist ? 'none' : '';
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // IMPORTANT:
        // - "is-active" is used by the theme as the *current* selected thumbnail.
        // - We must NOT use it to mark the active variant-group, otherwise thumbnail
        //   clicks stop working after the first selection.
        //
        // Instead, we hide non-matching group media with a dedicated class.

        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach((slide) => {
          if (!slide.dataset.group) return;
          slide.classList.toggle('is-hidden', slide.dataset.group !== group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach((thumb) => {
          if (!thumb.dataset.group) return;
          thumb.classList.toggle('is-hidden', thumb.dataset.group !== group);
        });

        // If we have a slider instance, reload cells so Flickity recalculates.
        try {
          const flkty = this.productSliderSection?.productSlider?.productSlider?.flkty;
          if (flkty) {
            flkty.reloadCells();
            flkty.resize();
          }
        } catch (e) {}
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }


// VA FIX: este método chamava-se também "connectedCallback", o que sobrepunha
// silenciosamente o connectedCallback original (linha ~30) — nunca corriam
// updateOptions()/setDisabled()/setImageSet() no carregamento da página.
// Isso deixava os estados "disabled" vindos do servidor (ex: produto todo
// esgotado) por limpar até o utilizador conseguir clicar em algo — o que
// nem sempre era possível, criando um impasse (nada clicável, logo nunca
// disparava onVariantChange para corrigir o disabled).
__vaConnectedCallbackExtra() {
  // Ensure our pending-media sync + full variant dataset are prepared.
  // (Safe to call multiple times.)
  this.__vaInitPendingMediaSync();
  this.__vaEnsureFullVariantData();
}

async __vaEnsureFullVariantData() {
  if (this.__vaFullVariantDataRequested) return;
  this.__vaFullVariantDataRequested = true;

  try {
    // IMPORTANT: must be THIS instance's own product URL, not the current page's URL.
    // Falling back to window.location.pathname is wrong whenever this <variant-selects>
    // belongs to a drawer/quick-view for a DIFFERENT product than the page you're on
    // (e.g. Shop the Look) — it would silently fetch and apply the WRONG product's variants.
    const raw = this.closest('.thb-product-detail')?.getAttribute('data-product-url') || '';
    const productUrl = raw.split('?')[0].replace(/\.js$/, '');
    if (!productUrl || !productUrl.includes('/products/')) return;

    const res = await fetch(`${productUrl}.js`, { credentials: 'same-origin' });
    if (!res.ok) return;

    const product = await res.json();
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return;

    this.variantData = product.variants;
    this.__vaVariantDataSource = 'product.js';
  } catch (e) {}
}

__vaInitPendingMediaSync() {
  if (this.__vaPendingInit) return;
  this.__vaPendingInit = true;

  const root = this.closest('.thb-product-detail') || document;
  this.__vaObserver = new MutationObserver(() => {
    if (window.__vaPendingMediaId) this.__vaTryApplyPendingMedia('mutation');
  });
  this.__vaObserver.observe(root, { childList: true, subtree: true });

  window.addEventListener('popstate', () => {
    if (window.__vaPendingMediaId) this.__vaTryApplyPendingMedia('popstate');
  });
  // VA: detect theme section refresh that replaces the product gallery, then re-apply pending media.
  if (!window.__vaRefreshObserver) {
    const getSlider = () =>
      document.querySelector('product-slider#Product-Slider, .thb-product-detail product-slider.product-images, .thb-product-detail .product-images, .product-images');

    window.__vaPrevProductSlider = getSlider();

    window.__vaRefreshObserver = new MutationObserver(() => {
      const sliderNow = getSlider();
      if (!sliderNow) return;

      // If slider element got replaced, a section refresh likely completed.
      if (window.__vaPrevProductSlider && sliderNow !== window.__vaPrevProductSlider) {
        window.__vaPrevProductSlider = sliderNow;
        window.__vaExpectingSectionRefresh = false;
        try {
          // Try to apply using any existing VariantSelects instance on the page
          const vs = document.querySelector('variant-selects, variant-radios');
          if (vs && typeof vs.__vaTryApplyPendingMedia === 'function') {
            vs.__vaTryApplyPendingMedia('afterRefresh');
          }
        } catch (e) {}
      }
    });

    window.__vaRefreshObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

}

__vaSetPendingMedia(mediaId) {
  if (!mediaId) return;
  window.__vaPendingMediaId = String(mediaId);
  window.__vaPendingSectionId = String(this.dataset.section || '');

  // Only defer when a section refresh will replace the gallery DOM.
  // On colour-only changes (no section refresh), deferring causes a visible delay.
  const expectingRefresh = !!window.__vaExpectingSectionRefresh;

  clearTimeout(window.__vaPendingApplyTimer);

  if (!expectingRefresh) {
    // Apply on the next frame (fast)
    window.__vaExpectingSectionRefresh = false;
    requestAnimationFrame(() => this.__vaTryApplyPendingMedia('noRefreshRaf'));
    return;
  }

  // We *only* apply media after the theme has finished its section refresh (if any).
  // The observer will call __vaTryApplyPendingMedia() once it detects the new slider DOM.
  window.__vaExpectingSectionRefresh = true;

  // Fallback: if refresh detection fails, apply after a short delay.
  window.__vaPendingApplyTimer = setTimeout(() => {
    window.__vaExpectingSectionRefresh = false;
    this.__vaTryApplyPendingMedia('fallback900');
  }, 900);
}

__vaTryApplyPendingMedia(from) {
  const mediaId = window.__vaPendingMediaId;
  if (window.__vaExpectingSectionRefresh) return;
  if (!mediaId) return;

  const section = window.__vaPendingSectionId || this.dataset.section || '';
  const productSlider =
    this.closest('.thb-product-detail')?.querySelector('product-slider#Product-Slider') ||
    this.closest('.thb-product-detail')?.querySelector('.product-images') ||
    null;

  if (!productSlider) return;

  const slideId = section ? `#Slide-${section}-${mediaId}` : `[data-media-id*="${mediaId}"]`;
  const slide = document.querySelector(slideId);
  if (!slide) return;

  const thumbId = section ? `#Thumb-${section}-${mediaId}` : null;
  const thumbnails = this.closest('.thb-product-detail')?.querySelector('#Product-Thumbnails') || null;

  try {
    this.setActiveMedia(slideId, thumbId, productSlider, thumbnails);
    window.__vaPendingMediaId = null;
  } catch (e) {
    // keep pending; observer/timers will retry
  }
}

  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
    updateVariantText() {


    }
  }

  customElements.define('variant-radios', VariantRadios);


  // ===== HIGH VARIANTS: update price/media/availability using option_values (supports 1000+ variants) =====
  // Works for the normal PDP AND for any drawer/quick-view where this markup gets injected later
  // (e.g. Shop the Look), since <script> tags inside innerHTML never execute on their own.
  function initHighVariants(root) {
    if (!root || root.__vaHighVariantsInit) return;
    root.__vaHighVariantsInit = true;

    try {
    const sectionId = root.getAttribute('data-section-id');
    const productUrl = root.getAttribute('data-product-url') || window.location.pathname;

    const isColorOptionName = (name) => /colou?r/i.test(String(name || ''));
    const isColorFieldset = (fs) => isColorOptionName(fs?.dataset?.handle);

    function getSelectedOptionValueIds() {
      const ids = [];
      root.querySelectorAll('fieldset[data-index]').forEach((fs) => {
        // radios
        const checked = fs.querySelector('input[type="radio"][data-option-value-id]:checked');
        if (checked && checked.dataset.optionValueId) {
          ids.push(checked.dataset.optionValueId);
          return;
        }
        // selects
        const sel = fs.querySelector('select');
        if (sel) {
          const opt = sel.options[sel.selectedIndex];
          if (opt && opt.dataset && opt.dataset.optionValueId) ids.push(opt.dataset.optionValueId);
        }
      });
      return ids.filter(Boolean);
    }

    function buildSectionUrl() {
      const ids = getSelectedOptionValueIds();
      const u = new URL(productUrl, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      if (ids.length) u.searchParams.set('option_values', ids.join(','));
      return u.toString();
    }

    
    // --- HIGH VARIANTS: ATC state sync (fixes "UNAVAILABLE" text when variant is actually available) ---
    let __vaAtcCache = new Map(); // variantId -> {available:boolean, title?:string}
    let __vaAtcAbort = null;

    function getCurrentVariantId() {
      const idEl = root.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
      return idEl && idEl.value ? String(idEl.value) : '';
    }

    function getAtcButtons() {
      return Array.from(root.querySelectorAll(
        'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"], button[name="add"], button[type="submit"][name="add"]'
      ));
    }

    function setAtcLabel(btn, text) {
      // Theme-specific: ATC buttons often contain multiple spans (label + loading overlay).
      // We want the *label* node, not the overlay.
      const spans = Array.from(btn.querySelectorAll('span'));
      const labelSpan = spans.find((s) => !s.classList.contains('loading-overlay'))
        || spans.find((s) => !s.querySelector('svg'))
        || spans[0];

      // If the label span isn't obvious, fall back to any descendant whose text matches known labels.
      const textNode = labelSpan || Array.from(btn.querySelectorAll('*')).find((x) => {
        const t = (x.textContent || '').trim().toLowerCase();
        return t === 'sold out' || t === 'unavailable' || t === 'add to cart' || t === 'pre-order';
      }) || btn;

      textNode.textContent = text;
    }

    async function syncAtcFromVariantId(variantId) {
      if (!variantId) return;

      // Abort previous availability check to avoid race conditions on rapid option changes
      try { if (__vaAtcAbort) __vaAtcAbort.abort(); } catch(e) {}
      __vaAtcAbort = new AbortController();

      // Cache hit
      if (__vaAtcCache.has(variantId)) {
        const { available } = __vaAtcCache.get(variantId);
        applyAtcState(available);
        return;
      }

      try {
        const vRes = await fetch(`/variants/${variantId}.js`, {
          credentials: 'same-origin',
          signal: __vaAtcAbort.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!vRes.ok) return;
        const v = await vRes.json();
        const available = !!v.available;
        __vaAtcCache.set(variantId, { available });
        applyAtcState(available);
      } catch (e) {
        // ignore abort/network
      }
    }

    function applyAtcState(available) {
      const buttons = getAtcButtons();
      if (!buttons.length) return;

      buttons.forEach((btn) => {
        // Capture original label once (DO NOT use current textContent; it might already be "Sold out")
        if (!btn.dataset.originalText) {
          btn.dataset.originalText =
            btn.getAttribute('data-original-text') ||
            (window.theme && window.theme.variantStrings && window.theme.variantStrings.addToCart) ||
            'Add to cart';
        }
        const soldOutText =
          btn.dataset.soldOutText ||
          btn.getAttribute('data-sold-out-text') ||
          btn.getAttribute('data-unavailable-text') ||
          'Sold out';

        // Force state
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', (!available).toString());
        btn.classList.toggle('disabled', !available);
        // Theme uses these classes to style the sold-out state
        btn.classList.toggle('sold-out', !available);
        btn.classList.toggle('button--sold-out', !available);

        setAtcLabel(btn, available ? btn.dataset.originalText : soldOutText);
      });
    }


    // VA: iOS/Safari can jump to top on size change during section refresh, which breaks the carousel.
    // Lock the page scroll position during the async refresh to prevent scroll anchoring/focus jumps.
    //
    // VA: made reentrant (depth counter) — several places in this file lock/unlock independently
    // (renderProductInfo, refreshSection, setActiveMedia, and the outer "whole interaction" lock
    // added below). Without a counter, an inner lock/unlock pair would read/clear the saved Y while
    // an outer lock is still active, causing the outer unlock to restore to the wrong position
    // (typically 0, i.e. right back to the very jump-to-top we're trying to prevent).
    // Only the OUTERMOST lock call actually captures Y / applies position:fixed; only the
    // outermost matching unlock call actually restores it.
    window.__vaScrollLockDepth = window.__vaScrollLockDepth || 0;
    window.__vaScrollLockY = window.__vaScrollLockY || 0;

    function __vaLockPageScroll() {
      if (window.__vaScrollLockDepth === 0) {
        const y = window.scrollY || 0;
        window.__vaScrollLockY = y;
        document.documentElement.style.scrollBehavior = 'auto';
        document.body.dataset.vaScrollY = String(y);
        document.body.style.position = 'fixed';
        document.body.style.top = `-${y}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
      window.__vaScrollLockDepth += 1;
      return window.__vaScrollLockY;
    }

    function __vaUnlockPageScroll(savedY, skipRestore) {
      window.__vaScrollLockDepth = Math.max(0, window.__vaScrollLockDepth - 1);
      if (window.__vaScrollLockDepth > 0) return; // still locked by an outer caller

      const y = typeof savedY === 'number' ? savedY : Number(document.body.dataset.vaScrollY || window.__vaScrollLockY || 0);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.vaScrollY;
      // VA: skipRestore lets the deferred image-focus scroll (which happened silently while we
      // were position:fixed) stand as the final resting position, instead of snapping back to
      // where the user originally clicked (the "back to size selection" middle step).
      if (skipRestore) return;
      // Restore scroll immediately and reinforce next frame (Safari sometimes adjusts after layout)
      window.scrollTo(0, y);
      requestAnimationFrame(() => window.scrollTo(0, y));
    }

let __vaMediaSyncTimer = null;
let __vaLastMediaSyncKey = '';
let __vaVariantHtmlCache = new Map();
let __vaVariantFetchController = null;
let __vaMediaSyncFromSectionRefresh = false;

function vaGetSelectionKey() {
  return getSelectedOptionValueIds().join(',');
}

function instantSwapImageFromSwatchInput(input) {
  if (!input) return;

  const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
  if (!label) return;

  const swatchImg = label.querySelector('img');
  if (!swatchImg) return;

  const swatchSrc = swatchImg.currentSrc || swatchImg.src;
  if (!swatchSrc) return;

  const currentGallery = document.querySelector(`#MediaGallery-${sectionId}`);
  if (!currentGallery) return;

  const activeImg =
    currentGallery.querySelector('.product-images__slide.is-selected img') ||
    currentGallery.querySelector('.product-images__slide.is-active img') ||
    currentGallery.querySelector('.flickity-slider .is-selected img') ||
    currentGallery.querySelector('img');

  if (!activeImg) return;

  activeImg.src = swatchSrc;
  if (activeImg.srcset) activeImg.srcset = '';
}

async function fetchVariantHTMLWithCache() {
  const key = vaGetSelectionKey();
  if (!key) return null;

  if (__vaVariantHtmlCache.has(key)) {
    return __vaVariantHtmlCache.get(key);
  }

  if (__vaVariantFetchController) {
    __vaVariantFetchController.abort();
  }

  __vaVariantFetchController = new AbortController();

  const url = buildSectionUrl();

  try {
    const res = await fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: __vaVariantFetchController.signal
    });

    if (!res.ok) return null;

    const html = await res.text();
    __vaVariantHtmlCache.set(key, html);
    return html;
  } catch (e) {
    return null;
  }
}

function getOptionValueIdsWithOverride(changedInput) {
  const ids = [];

  root.querySelectorAll('fieldset[data-index]').forEach((fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"][data-option-value-id]:checked');
    if (checked) ids.push(checked.getAttribute('data-option-value-id'));
  });

  if (changedInput) {
    const changedId = changedInput.getAttribute('data-option-value-id');
    const fieldset = changedInput.closest('fieldset[data-index]');
    const currentChecked = fieldset?.querySelector('input[type="radio"][data-option-value-id]:checked');
    const currentId = currentChecked?.getAttribute('data-option-value-id');

    const idx = ids.indexOf(currentId);
    if (idx !== -1) {
      ids[idx] = changedId;
    }
  }

  return ids.filter(Boolean);
}

function prefetchForInput(input) {
  const ids = getOptionValueIdsWithOverride(input);
  if (!ids.length) return;

  const key = ids.join(',');
  if (__vaVariantHtmlCache.has(key)) return;

  const u = new URL(productUrl, window.location.origin);
  u.searchParams.set('section_id', sectionId);
  u.searchParams.set('option_values', key);

  fetch(u.pathname + '?' + u.searchParams.toString(), {
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(res => res.ok ? res.text() : null)
    .then(html => {
      if (html) __vaVariantHtmlCache.set(key, html);
    })
    .catch(() => {});
}

    function getVariantMediaIdFromHTML(doc) {
  const newGallery = doc.querySelector(`#MediaGallery-${sectionId}`);
  if (!newGallery) return null;

  const activeMedia =
    newGallery.querySelector('.product-images__slide.is-selected[data-media-id]') ||
    newGallery.querySelector('.product-images__slide.is-active[data-media-id]') ||
    newGallery.querySelector('[data-media-id].is-selected') ||
    newGallery.querySelector('[data-media-id].is-active') ||
    newGallery.querySelector('[data-media-id][aria-current="true"]');

  if (activeMedia) {
    return activeMedia.getAttribute('data-media-id');
  }

  const firstMedia = newGallery.querySelector('[data-media-id]');
  return firstMedia ? firstMedia.getAttribute('data-media-id') : null;
}

function clickThemeThumbnailByMediaId(mediaId) {
  if (!mediaId) return;

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  const sliderRoot =
    root.querySelector('.product-images');

  const slide =
    document.querySelector(`#Slide-${sectionId}-${mediaId}`) ||
    root.querySelector(`[data-media-id="${mediaId}"]`) ||
    document.querySelector(`[data-media-id="${mediaId}"]`);

  if (!sliderRoot || !slide) {

    return;
  }

  // MOBILE: usar Flickity diretamente pela cell real
if (isMobile && sliderRoot.flkty) {
  const cell = sliderRoot.flkty.getCell(slide);

if (
  isIOS() &&
  !vaNeedsMediaFallback() &&
  __vaMediaSyncFromSectionRefresh &&
  cell &&
  typeof cell.index === 'number' &&
  typeof sliderRoot.flkty.select === 'function'
) {
  try { sliderRoot.flkty.select(cell.index, false, false); } catch (e) {}
  __vaMediaSyncFromSectionRefresh = false;
  return;
}

if (cell && typeof sliderRoot.flkty.selectCell === 'function') {
  try {
    sliderRoot.flkty.selectCell(slide, false, true);
  } catch (e) {

  }
  __vaMediaSyncFromSectionRefresh = false;
  return;
}
}

  // DESKTOP / FALLBACK
  const thumbnailsRoot =
    root.querySelector('.product-thumbnail-container');

  if (!thumbnailsRoot) {
    // No thumbnails strip in this context (e.g. the Shop the Look quick-view drawer).
    // Fall back to driving Flickity directly, same approach as the mobile path above.
    // Clear existing active states first so the previous slide doesn't stay visible
    // alongside the new one (mirrors the cleanup setActiveMedia() does).
    sliderRoot.querySelectorAll('.product-images__slide.is-active, .product-images__slide.is-initial-selected, .product-images__slide.is-selected')
      .forEach((el) => el.classList.remove('is-active', 'is-initial-selected', 'is-selected'));
    slide.classList.add('is-active', 'is-initial-selected', 'is-selected');

    const flkty = sliderRoot.flkty || (window.Flickity ? window.Flickity.data(sliderRoot) : null);
    if (flkty) {
      try { if (typeof flkty.resize === 'function') flkty.resize(); } catch (e) {}
      if (typeof flkty.selectCell === 'function') {
        try {
          flkty.selectCell(slide, false, false);
        } catch (e) {}
        return;
      }
    }
    if (typeof slide.scrollIntoView === 'function') {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
    return;
  }

  const thumb =
    thumbnailsRoot.querySelector(`#Thumb-${sectionId}-${mediaId}`) ||
    thumbnailsRoot.querySelector(`[id$="${mediaId}"]`);


  if (thumb && typeof thumb.click === 'function') {
    thumb.click();
    return;
  }

  thumb?.dispatchEvent(new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  }));
}

function prefetchAllColorSwatchesForCurrentSelection() {
  const colorInputs = Array.from(
    root.querySelectorAll('fieldset[data-index] input[type="radio"][data-option-value-id]')
  ).filter((input) => {
    const fieldset = input.closest('fieldset[data-index]');
    if (!fieldset) return false;
    return isColorFieldset(fieldset);
  });

  let i = 0;

  function runNext() {
    if (i >= colorInputs.length) return;

    const input = colorInputs[i++];
    prefetchForInput(input);

    setTimeout(runNext, 15);
  }

  runNext();
}

async function syncVariantIdAndButtonFromDoc(doc) {
  if (!doc) return;

  const newIdInput =
    doc.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    doc.querySelector('input[name="id"]');

  if (!newIdInput || !newIdInput.value) return;

  const newVariantId = String(newIdInput.value);

  // atualizar todos os hidden inputs de add-to-cart
  document.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"]')
    .forEach((el) => { el.value = newVariantId; });

  // confirmar disponibilidade real da variante
  try {
    const res = await fetch(`/variants/${newVariantId}.js`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) return;

    const variant = await res.json();
    const available = !!variant.available;

    const addBtn =
      document.querySelector('button[name="add"]') ||
      document.querySelector('.product-form__submit');

    if (!addBtn) return;

    addBtn.disabled = !available;
    addBtn.classList.toggle('disabled', !available);
    addBtn.classList.toggle('is-disabled', !available);

    // VA FIX: removed the textTarget.textContent write that hardcoded "Unavailable" here.
    // This is the duplicate of the same function in main-product.liquid — both were racing
    // against product.js's own toggleAddButton()/applyAtcState() for control of the button's
    // visible label (and of whatever a back-in-stock app like Klaviyo had placed there).
    // Disabled/class state is still updated here (needed for the 250+ variant fallback path);
    // only the text write was removed.
  } catch (e) {}
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent || '');
}

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

async function refreshSection() {
      const __vaSavedY = __vaLockPageScroll();
      // VA: becomes true below if a deferred (setTimeout/rAF) media-sync step will run —
      // in that case we must NOT unlock in the `finally` below, because unlocking early
      // (before that deferred step fires) is exactly what caused the "flash to variants,
      // then jump to top" bug: the page snaps back to Y while still unlocked, then the
      // late thumbnail/flickity sync moves the gallery and drags the page along with it.
      let __vaDeferredUnlock = false;
      try {

      // VA: let product.js know the gallery DOM will be replaced (avoid flicker on size changes)
      window.__vaExpectingSectionRefresh = true;
      const url = buildSectionUrl();
      const res = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const refreshedMediaId = getVariantMediaIdFromHTML(doc);
    

      const newInfo = doc.querySelector(`#ProductInfo-${sectionId}`);
      const newGallery = doc.querySelector(`#MediaGallery-${sectionId}`);

      const curInfo = document.querySelector(`#ProductInfo-${sectionId}`);
      const curGallery = document.querySelector(`#MediaGallery-${sectionId}`);

      if (newInfo && curInfo) curInfo.innerHTML = newInfo.innerHTML;
      if (vaNeedsMediaFallback()) {
  if (newGallery && curGallery) curGallery.innerHTML = newGallery.innerHTML;
}

      // After section swap, force swatch (sold-out/disabled) states to refresh for the current size
      requestAnimationFrame(() => requestAnimationFrame(() => __vaTriggerColourRecalc()));


      // After section swap, re-sync ATC state from the resolved variant id (fixes >250 'UNAVAILABLE' label)
      queueMicrotask(() => syncAtcFromVariantId(getCurrentVariantId()));

      // keep URL in sync if theme uses it elsewhere
      try {
        const ids = getSelectedOptionValueIds();
        const u = new URL(window.location.href);
        if (ids.length) u.searchParams.set('option_values', ids.join(','));
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    
           if (vaNeedsMediaFallback() && refreshedMediaId) {
  __vaDeferredUnlock = true;
  if (isIOS()) {
    setTimeout(() => {
      requestAnimationFrame(() => {
        const currentSelected = root.querySelector('.product-images .is-selected[data-media-id]');
        const currentMediaId = currentSelected ? currentSelected.getAttribute('data-media-id') : null;

        if (String(currentMediaId) !== String(refreshedMediaId)) {
          __vaMediaSyncFromSectionRefresh = true;
scheduleThemeThumbnailClick(refreshedMediaId);
        }

        const sliderRoot =
          root.querySelector('.product-images');

        if (sliderRoot?.flkty && typeof sliderRoot.flkty.resize === 'function') {
          try { sliderRoot.flkty.resize(); } catch (e) {}
        }

        // VA: only now is it safe to restore scroll — the deferred gallery sync above has settled.
        __vaUnlockPageScroll(__vaSavedY);
      });
    }, 120);
  } else {
    requestAnimationFrame(() => {
      const currentSelected = root.querySelector('.product-images .is-selected[data-media-id]');
      const currentMediaId = currentSelected ? currentSelected.getAttribute('data-media-id') : null;

      if (String(currentMediaId) !== String(refreshedMediaId)) {
        __vaMediaSyncFromSectionRefresh = true;
scheduleThemeThumbnailClick(refreshedMediaId);
      }

      // VA: same reasoning as the iOS branch above — unlock only after the sync has run.
      __vaUnlockPageScroll(__vaSavedY);
    });
  }
}

      await syncVariantIdAndButtonFromDoc(doc);

      } finally {
        // VA: if a deferred branch above already took ownership of unlocking, don't double-unlock —
        // __vaUnlockPageScroll() clears the saved-Y dataset on first call, so a second call here
        // would fall back to Y=0 and yank the page to the top itself.
        if (!__vaDeferredUnlock) __vaUnlockPageScroll(__vaSavedY);
      }
}

function scheduleThemeThumbnailClick(mediaId) {
  if (!mediaId) return;

  const syncKey = String(mediaId);
  __vaLastMediaSyncKey = syncKey;

  if (__vaMediaSyncTimer) {
    clearTimeout(__vaMediaSyncTimer);
    __vaMediaSyncTimer = null;
  }

  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const isiOS = isIOS();
  const isAndroidDevice = isAndroid();

  const delay = isiOS ? 60 : (isMobile ? 20 : 0);

  __vaMediaSyncTimer = setTimeout(() => {
    if (__vaLastMediaSyncKey !== syncKey) return;

    if (isiOS) {
      clickThemeThumbnailByMediaId(mediaId);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const sliderRoot =
            root.querySelector('.product-images');

          if (sliderRoot?.flkty && typeof sliderRoot.flkty.resize === 'function') {
            try { sliderRoot.flkty.resize(); } catch (e) {}
          }
        });
      });

      return;
    }

    if (isMobile && isAndroidDevice) {
      clickThemeThumbnailByMediaId(mediaId);

      requestAnimationFrame(() => {
        if (__vaLastMediaSyncKey !== syncKey) return;
        clickThemeThumbnailByMediaId(mediaId);
      });

      return;
    }

    clickThemeThumbnailByMediaId(mediaId);
  }, delay);
}

function vaNeedsMediaFallback() {
  const vs = root.querySelector('variant-selects, variant-radios');
  const cv = vs && vs.currentVariant ? vs.currentVariant : null;
  const fm = cv && cv.featured_media ? cv.featured_media : null;
  const mediaId = fm ? (fm.id || fm.media_id) : null;
  return !mediaId;
}

    async function refreshVariantIdOnly() {
      const html = await fetchVariantHTMLWithCache();
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const refreshedMediaId = getVariantMediaIdFromHTML(doc);
    

      const newIdInput =
        doc.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        doc.querySelector('input[name="id"]');

      if (!newIdInput || !newIdInput.value) return;

      const newVariantId = String(newIdInput.value);

      // Update all add-to-cart forms' variant id inputs in the current DOM
      root.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"]').forEach((el) => {
        el.value = newVariantId;
      });

      // Fetch variant JSON to get correct availability beyond the 250 variants limit
      await syncAtcFromVariantId(newVariantId);

      // keep URL in sync if theme uses it elsewhere
      try {
        const ids = getSelectedOptionValueIds();
        const u = new URL(window.location.href);
        if (ids.length) u.searchParams.set('option_values', ids.join(','));
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
      
const isMobileViewport = window.matchMedia('(max-width: 767px)').matches;

if ((isMobileViewport || vaNeedsMediaFallback()) && refreshedMediaId) {
  requestAnimationFrame(() => {
    const currentSelected = root.querySelector('.product-images .is-selected[data-media-id]');
    const currentMediaId = currentSelected ? currentSelected.getAttribute('data-media-id') : null;

    if (String(currentMediaId) !== String(refreshedMediaId)) {
      __vaMediaSyncFromSectionRefresh = false;
      scheduleThemeThumbnailClick(refreshedMediaId);
    }
  });
}

    }




    // --- HIGH VARIANTS: swatch availability recalc after section swap (size/type changes) ---
    // Some theme scripts only recompute swatch disabled/sold-out states when the *colour* option changes.
    // After we swap ProductInfo via section rendering, we trigger a synthetic colour change so swatches update immediately.
    let __vaSkipNextSyntheticChange = false;

    function __vaTriggerColourRecalc() {
      // Find the colour fieldset by data-handle (no Liquid dependency needed)
      const colourFs = Array.from(root.querySelectorAll('fieldset[data-index]')).find(isColorFieldset);
      if (!colourFs) return;

      // Prefer checked radio; fallback to select
      const el =
        colourFs.querySelector('input[type="radio"][data-option-value-id]:checked') ||
        colourFs.querySelector('input[type="radio"]:checked') ||
        colourFs.querySelector('select');

      if (!el) return;

      __vaSkipNextSyntheticChange = true;

      // Fire both input + change to satisfy different theme listeners
      try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch(e) {}
      try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch(e) {}
    }

          // Initial sync on load
      queueMicrotask(() => syncAtcFromVariantId(getCurrentVariantId()));

let raf = null;
    root.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;
      const isVariantInput = t.matches('input[type="radio"][data-option-value-id], select');
      if (!isVariantInput) return;

      if (__vaSkipNextSyntheticChange) { __vaSkipNextSyntheticChange = false; return; }

      // detect which option changed (e.g. size vs colour)
      const fieldset = t.closest('fieldset[data-index]');

      // ✅ changing colour within the same size doesn't change price -> skip section refresh
      // this avoids Shop Pay terms ("Pay in 2...") flicker and layout shift
if (isColorFieldset(fieldset)) {
  if (window.matchMedia('(min-width: 768px)').matches && !isAndroid()) {
    instantSwapImageFromSwatchInput(t);
  }
  // VA: same outer blanket lock as the size branch below — without it, setActiveMedia()'s own
  // internal lock (added to stop Flickity's focus-triggered jump) is the outermost lock in this
  // path, and it restores scroll back to the original click position by default, which is why
  // colour changes previously didn't visibly move to the image at all. skipRestore=true lets the
  // image-focus scroll stick here too, matching the size behaviour.
  // VA: colour only ever takes the FAST rAF path (no network fetch, no 900ms fallback like size
  // can hit), so the image-focus scroll happens almost immediately. Holding the lock for 1600ms
  // here was pure artificial delay — nothing async worth waiting for actually takes that long.
  if (!window.matchMedia('(min-width: 768px)').matches) {
    const __vaColorSavedY = __vaLockPageScroll();
    setTimeout(() => __vaUnlockPageScroll(__vaColorSavedY, true), 150);
  }
  refreshVariantIdOnly();
  return;
}

// debounce to avoid multiple fetches when DOM updates
if (raf) cancelAnimationFrame(raf);

// VA: outer, brute-force scroll lock for the WHOLE size-change cascade (mobile only).
// Rather than chasing every individual setTimeout/rAF inside refreshSection/setActiveMedia/
// __vaSetPendingMedia's 900ms fallback (which kept surfacing new unprotected paths), lock the
// scroll synchronously right here, the instant the size change is detected, and only release it
// after a fixed window generous enough to outlast every known deferred step (900ms fallback +
// fetch + DOM swap + rAFs). This trades a brief period of "can't manually scroll" right after
// tapping a size for a guaranteed end to the jump-to-top.
const __vaOuterIsMobile = !window.matchMedia('(min-width: 768px)').matches;
let __vaOuterSavedY = null;
if (__vaOuterIsMobile) {
  __vaOuterSavedY = __vaLockPageScroll();
  // VA: skipRestore=true — don't force scroll back to the click position; let the page settle
  // wherever the deferred image sync (Flickity focus) already moved it to.
  setTimeout(() => __vaUnlockPageScroll(__vaOuterSavedY, true), 1600);
}

raf = requestAnimationFrame(() => {
  refreshSection();
  setTimeout(() => {
    prefetchAllColorSwatchesForCurrentSelection();
  }, 0);
});
});

    document.addEventListener('pointerdown', (e) => {
  const input = e.target.closest('label')?.querySelector('input[type="radio"][data-option-value-id]')
    || e.target.closest('input[type="radio"][data-option-value-id]');

  if (!input) return;
  prefetchForInput(input);
}, true);

document.addEventListener('mouseover', (e) => {
  const input = e.target.closest('label')?.querySelector('input[type="radio"][data-option-value-id]')
    || e.target.closest('input[type="radio"][data-option-value-id]');

  if (!input) return;
  prefetchForInput(input);
}, true);

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    prefetchAllColorSwatchesForCurrentSelection();
  }, { timeout: 1500 });
} else {
  setTimeout(() => {
    prefetchAllColorSwatchesForCurrentSelection();
  }, 800);
}
document.addEventListener('touchstart', (e) => {
  const input = e.target.closest('label')?.querySelector('input[type="radio"][data-option-value-id]')
    || e.target.closest('input[type="radio"][data-option-value-id]');

  if (!input) return;
  prefetchForInput(input);
}, { capture: true, passive: true });
    } catch (vaErr) {
      console.error('HIGH VARIANTS: failed to initialize', vaErr);
    }
  }

  // Init for markup already present on the page at load time (normal PDP).
  document.querySelectorAll('.thb-product-detail.product[data-section-id]').forEach(initHighVariants);

  // Init for markup injected later (e.g. the Shop the Look quick-view drawer).
  if (!window.__vaHighVariantsObserver) {
    window.__vaHighVariantsObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.thb-product-detail.product[data-section-id]')) {
            initHighVariants(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.thb-product-detail.product[data-section-id]').forEach(initHighVariants);
          }
        });
      });
    });
    window.__vaHighVariantsObserver.observe(document.body, { childList: true, subtree: true });
  }


}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      }
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        // IMPORTANT:
        // - `.is-active` is used by the theme to indicate the *currently selected* thumbnail.
        // - We use `.is-hidden` for variant-set filtering, so Flickity must ignore those.
        cellSelector: '.product-images__slide:not(.is-hidden)'
      };

      if (this.classList.contains('product-quick-images')) {
        this.options.cellAlign = 'left';
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
this.flkty.on('change', (index) => {
  const previousCell = this.flkty && this.flkty.cells ? this.flkty.cells[_this.selectedIndex] : null;
  const nextCell = this.flkty && this.flkty.cells ? this.flkty.cells[index] : null;

  const previous_slide = previousCell && previousCell.element ? previousCell.element : null;
  const slide = nextCell && nextCell.element ? nextCell.element : null;

  const previous_media = previous_slide ? previous_slide.querySelector('.product-single__media') : null;
  const media = slide ? slide.querySelector('.product-single__media') : null;

  let active_thumb = null;

  if (this.thumbnail_container && this.thumbnails && this.thumbnails.length) {
    const visible_thumbs = Array.from(this.thumbnails).filter((el) => {
      return !el.classList.contains('is-hidden') && el.clientWidth > 0;
    });

    active_thumb = visible_thumbs[index] || visible_thumbs[0] || null;

    this.thumbnails.forEach((item) => {
      item.classList.remove('is-initial-selected');
    });

    if (active_thumb) {
      active_thumb.classList.add('is-initial-selected');
    }
  }

  requestAnimationFrame(() => {
    if (!active_thumb) return;
    if (!active_thumb.offsetParent) return;
    if (!active_thumb.parentElement || typeof active_thumb.parentElement.scrollTo !== 'function') return;

    const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2;
    const windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;

    active_thumb.parentElement.scrollTo({
      left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
      top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
      behavior: 'smooth'
    });
  });

  // Stop previous video
  if (previous_media && previous_media.classList.contains('product-single__media-external-video')) {
    if (previous_media.dataset.provider === 'youtube') {
      const frame = previous_media.querySelector('iframe');
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage(JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: ""
        }), "*");
      }
    } else if (previous_media.dataset.provider === 'vimeo') {
      const frame = previous_media.querySelector('iframe');
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage(JSON.stringify({
          method: "pause"
        }), "*");
      }
    }
  } else if (previous_media && previous_media.classList.contains('product-single__media-native-video')) {
    const video = previous_media.querySelector('video');
    if (video) video.pause();
  }

  // Draggable
  if (media && media.classList.contains('product-single__media-model')) {
    this.setDraggable(false);
  } else {
    this.setDraggable(true);
  }
});

      if (this.thumbnail_container) {
        setTimeout(() => {
          this.thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => {
              const visible = Array.from(this.thumbnails).filter(el => {
                return !el.classList.contains('is-hidden') && el.clientWidth > 0;
              });
              const idx = visible.indexOf(thumbnail);
              if (idx === -1) return;
              this.thumbnailClick(thumbnail, idx);
            });
          });
        });
      }
      let scrollbar = document.querySelector('.product-quick-images__scrollbar>div');

      if (scrollbar) {
        this.flkty.on('scroll', function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = 'scaleX(' + progress + ')';
        });
      }

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      // Build gallery from the currently visible slides (variant filtering uses `.is-hidden`).
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide:not(.is-hidden) .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      const formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');

        if (!document.getElementById('Cart-Drawer')) {
          this.body.classList.remove('open-cc');
        }
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

/* --------------------------------------------------------------------------
 * Preserve selected media across theme "section refresh" re-renders.
 * Some themes refresh the main-product section on option change, which resets the
 * product slider back to the first image. We re-apply the last variant media.
 * -------------------------------------------------------------------------- */
(function () {
  if (window.__vaMediaRestoreInstalled) return;
  window.__vaMediaRestoreInstalled = true;

  const getSlider = () => document.querySelector('product-slider#Product-Slider');

  const escId = (v) => (window.CSS && CSS.escape ? CSS.escape(String(v)) : String(v).replace(/[^a-zA-Z0-9_-]/g, '\$&'));
  const escAttr = (v) => String(v).replace(/["\\]/g, '\$&');

  const restore = () => {
    const slider = getSlider();
    const desiredId = window.__vaLastMediaId;
    if (!slider || !desiredId) return;

    // prefer dataset.mediaId match (theme uses "template--...-main-product-<id>")
    const cell =
      slider.querySelector(`[data-media-id$="-${escAttr(desiredId)}"]`) ||
      slider.querySelector(`[id$="-${escAttr(desiredId)}"]`) ||
      slider.querySelector(`[data-media-id*="${escAttr(desiredId)}"]`);

    if (cell) {
      try {
        // ProductSlider wrapper exists in this file
        if (typeof slider.selectCell === 'function') slider.selectCell(cell);
        else if (slider.flkty) slider.flkty.selectCell(cell);
      } catch (e) {}
    }
  };

  // 1) observe DOM changes inside the gallery (after section HTML swap)
  const obs = new MutationObserver(() => {
    // debounce to next frame so Flickity has time to init
    requestAnimationFrame(restore);
  });
  const startObs = () => {
    const slider = getSlider();
    if (slider) obs.observe(slider, { childList: true, subtree: true });
  };
  document.addEventListener('DOMContentLoaded', startObs);
  startObs();

  // 2) If the theme exposes a global refreshSection(), wrap it so we restore after it runs.
  if (typeof window.refreshSection === 'function' && !window.__vaRefreshWrapped) {
    window.__vaRefreshWrapped = true;
    const orig = window.refreshSection;
    window.refreshSection = async function () {
      // capture currently active slide (works even if variant media isn't set)
      try {
        const slider = getSlider();
        const active = slider?.querySelector('.product-images__slide.is-active, .product-images__slide[aria-current="true"], .product-images__slide[aria-hidden="false"]');
        const mid = active?.getAttribute('data-media-id') || active?.id || '';
        if (mid) window.__vaLastActiveMediaKey = mid;
      } catch (e) {}

      const res = await orig.apply(this, arguments);

      // After refresh, try variant media id first, fallback to previous active slide key.
      requestAnimationFrame(() => {
        if (key) {
          const cell = slider.querySelector(`[data-media-id="${escAttr(key)}"], #${escId(key)}`);
          if (cell) {
            try {
              if (typeof slider.selectCell === 'function') slider.selectCell(cell);
              else if (slider.flkty) slider.flkty.selectCell(cell);
            } catch (e) {}
          }
        }
      });

      return res;
    };
  }
})();